import { Clickable } from '@carvana/merch-components';
import { useContext } from 'react';
import { useUserLocation } from '~/context/common/UserContext';
import ModalContext from '~/context/vdp/ModalContext';
import { LearnMoreContainer } from './MarketValue.styles';

export default function MarketValue() {
  const location = useUserLocation();
  const { setMarketValueModalOpen } = useContext(ModalContext);
  const isInCalifornia = location.state === 'CA';

  return isInCalifornia ? (
    <LearnMoreContainer>
      Find out the reasonable market value of this vehicle{' '}
      <Clickable
        className="block text-blue-2 tl-link-s hover:text-blue-3 m:inline"
        data-analytics-id="Market Value - Learn more"
        onClick={() => {
          setMarketValueModalOpen(true);
        }}
        element="span"
      >
        Learn more
      </Clickable>
    </LearnMoreContainer>
  ) : null;
}
